import { API, authClient } from "../index";

export const getAllInvoices = ({ limit = 200, skip = 0, customerId } = {}) => {
  const params = { limit, skip };
  if (customerId) params.customerId = customerId;
  return authClient().get(`${API}/invoice`, { params });
};

export const regenerateInvoice = (invoiceId) => {
  return authClient().post(`${API}/invoice/${invoiceId}/regenerate`);
};

export const refundFullInvoice = (invoiceId) => {
  return authClient().post(`${API}/invoice/${invoiceId}/refund`);
};

export const downloadInvoicePdf = async (invoiceId) => {
  return authClient().get(`${API}/invoice/${invoiceId}/download`, {
    responseType: "blob",
  });
};

export const deleteInvoice = (invoiceId) => {
  return authClient().delete(`${API}/invoice/${invoiceId}`);
};

